import type { ObjectId } from "@bbj-types/utils";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import type { ISocialOfferWithFavoriteChallenges } from "../offers";
import { axiosStructurePartner, axiosStructurePartnerInstance } from "./axios";

export type IGetStructurePartnerOffersResponse = {
  offer: Pick<
    ISocialOfferWithFavoriteChallenges,
    | "offerId"
    | "name"
    | "serviceStartDate"
    | "serviceEndDate"
    | "organisation"
    | "url"
    | "services"
    | "tags"
    | "address"
    | "perimeter"
    | "source"
    | "externalId"
    | "favoriteChallenges"
    | "isRemote"
  > & {
    place?: string;
  };
  prescriptionCount: number;
  integratedCandidateCount: number;
}[];

export const useGetStructurePartnerOffers = () => {
  const [state, execute, cancel] = axiosStructurePartner<IGetStructurePartnerOffersResponse, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (structurePartnerId: ObjectId) => {
      return execute({
        url: `${structurePartnerId}/offers`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetStructurePartnerOffersSuspense = (structurePartnerId: ObjectId) => {
  return useSuspense(
    () => axiosStructurePartnerInstance.get<IGetStructurePartnerOffersResponse>(`/${structurePartnerId}/offers`),
    [structurePartnerId]
  );
};
